import { h, Component } from 'preact';
import { sidebarPopUps, flightList, glyphs, pipes, travelerNotices } from 'helpers/airportData.js';
import { joinClasses } from 'utils/utils';
import { isPlanet, isGlyphEasterEgg, isFlightEasterEgg, isTravelerNoticesEasterEgg } from 'helpers/index.js';
import BoardingTimes from 'components/bolt/airport/popUpWindows/boardingTimes/boardingTimes';
import Passport from 'components/bolt/airport/popUpWindows/passport/passport';
import TravelerNotices from 'components/bolt/airport/popUpWindows/travelerNotices/travelerNotices';
import LostAndFound from 'components/bolt/airport/popUpWindows/lostAndFound/lostAndFound';
import StayConnected from 'components/bolt/airport/popUpWindows/stayConnected/stayConnected';
import WatchAtHome from 'components/bolt/airport/popUpWindows/watchAtHome/watchAtHome';
import Planet from 'components/bolt/airport/popUpWindows/planet/planet';
import EasterEgg from 'components/bolt/airport/popUpWindows/easterEgg/easterEgg';
import Store from 'store/store';
import s from 'components/bolt/airport/popUpWindows/popUpWindows.sss';

export default class PopUpWindows extends Component {
	constructor(props) {
		super(props);
		this.onResize = this.onResize.bind(this);
		this.onPopUpDragStart = this.onPopUpDragStart.bind(this);
		this.onPopUpDrag = this.onPopUpDrag.bind(this);
		this.onPopUpDragEnd = this.onPopUpDragEnd.bind(this);
		this.setZIndexes = this.setZIndexes.bind(this);
		this.getPopUpDims = this.getPopUpDims.bind(this);
		this.state = {
			popUpDims: {},
			transformCenterString: '',
			popUpTransforms: {},
			popUpZIndexes: {},
		};
		this.displayedSidebarPopUps = sidebarPopUps.filter(s => !s.disabled);
	}

	componentDidMount() {
		this.getPopUpDims();
		this.setCenterString();
		window.addEventListener('resize', this.onResize);
		Store.on('EASTER_EGG_LOADED', this.getPopUpDims);
	}

	componentDidUpdate(prevProps) {
		const { openedWindows } = this.props;
		if (prevProps.openedWindows !== openedWindows) {
			const closedPopUp = prevProps.openedWindows.find(id => !openedWindows.includes(id));
			const { popUpTransforms } = this.state;
			if (popUpTransforms[closedPopUp]) {
				const newPopUpTransforms = { ...popUpTransforms, [closedPopUp]: null };
				this.setState({ popUpTransforms: newPopUpTransforms });
			}
			if (prevProps.openedWindows.length > openedWindows.length) {
				this.zIndexTimer = setTimeout(this.setZIndexes, 400);
			} else {
				this.setZIndexes();
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
		Store.off('EASTER_EGG_LOADED', this.getPopUpDims);
		this.zIndexTimer && clearTimeout(this.zIndexTimer);
	}

	onResize() {
		this.setCenterString();
	}

	onCloseClick(e, sectionId) {
		e.stopPropagation();
		const { toggleWindow } = this.props;
		toggleWindow(sectionId);
	}

	onPopUpDragStart(e, sectionId) {
		const { client, makeActiveWindow } = this.props;
		makeActiveWindow(sectionId);

		if (!client.isDesktopWidth) return;
		this.dragging = true;
		this.setState({ draggingPopUpId: sectionId });

		this.getPopUpDims();

		if (e.touches?.length === 1) {
			this.lastClientX = e.touches[0].clientX;
			this.lastClientY = e.touches[0].clientY;
		} else if (!e.touches) {
			this.lastClientX = e.clientX;
			this.lastClientY = e.clientY;
		}
	}

	onPopUpDrag(e, sectionId) {
		if (!this.dragging) return;
		const { client } = this.props;
		if (!client.isDesktopWidth) return;

		let clientX;
		let clientY;
		if (e.touches?.length === 1) {
			clientX = e.touches[0].clientX;
			clientY = e.touches[0].clientY;
		} else if (!e.touches) {
			clientX = e.clientX;
			clientY = e.clientY;
		} else {
			return;
		}
		const diffX = clientX - this.lastClientX;
		const diffY = clientY - this.lastClientY;
		this.lastClientX = clientX;
		this.lastClientY = clientY;

		const { popUpTransforms, popUpDims } = this.state;
		const popUpDim = popUpDims[sectionId];
		const minX = 0;
		const minY = 0;
		const maxX = window.innerWidth - (popUpDim.width || 607) - 8;
		const maxY = window.innerHeight - (popUpDim.height || 400) - 8;

		if (popUpTransforms[sectionId]) {
			const newPopUpTransforms = {
				...popUpTransforms,
				[sectionId]: {
					x: Math.min(Math.max((popUpTransforms[sectionId].x + diffX), minX), maxX),
					y: Math.min(Math.max((popUpTransforms[sectionId].y + diffY), minY), maxY)
				}
			};
			this.setState({ popUpTransforms: newPopUpTransforms });
		}
	}

	onPopUpDragEnd(e) {
		const { client } = this.props;
		if (!client.isDesktopWidth) return;
		this.dragging = false;
		this.setState({ draggingPopUpId: null });

	}

	getPopUpDims() {
		const popUpDims = {};
		this.displayedSidebarPopUps.forEach(section => {
			const $popUp = this[`$${section.id}PopUp`];
			if ($popUp) {
				const width = $popUp.clientWidth;
				const height = $popUp.clientHeight;
				popUpDims[section.id] = { width, height };
			}
		});
		flightList.forEach(flight => {
			if (flight.planet || flight.easterEgg) {
				const $popUp = this[`$${flight.id}PopUp`];
				if ($popUp) {
					const width = $popUp.clientWidth;
					const height = $popUp.clientHeight;
					popUpDims[flight.id] = { width, height };
				}
			}
		});
		travelerNotices.forEach(notice => {
			if (notice.easterEgg) {
				const $popUp = this[`$${notice.id}PopUp`];
				if ($popUp) {
					const width = $popUp.clientWidth;
					const height = $popUp.clientHeight;
					popUpDims[notice.id] = { width, height };
				}
			}
		});
		glyphs.forEach(glyph => {
			if (glyph.easterEgg) {
				const $popUp = this[`$${glyph.id}PopUp`];
				if ($popUp) {
					const width = $popUp.clientWidth;
					const height = $popUp.clientHeight;
					popUpDims[glyph.id] = { width, height };
				}
			}
		});
		pipes.forEach(pipe => {
			if (pipe.easterEgg) {
				const $popUp = this[`$${pipe.id}PopUp`];
				if ($popUp) {
					const width = $popUp.clientWidth;
					const height = $popUp.clientHeight;
					popUpDims[pipe.id] = { width, height };
				}
			}
		});
		this.setState({ popUpDims });
	}

	setZIndexes() {
		const { openedWindows } = this.props;
		const popUpZIndexes = {};
		openedWindows.forEach((id, index) => {
			popUpZIndexes[id] = index + 1;
		});
		this.setState({ popUpZIndexes });
	}

	setCenterString() {
		const centerString = `translate(calc(${window.innerWidth / 2}px - 50%), calc(${window.innerHeight / 2}px - 50%))`;
		this.setState({ transformCenterString: centerString });
	}

	getPopUpOpenTransformString(sectionId) {
		const { openedWindows, castleRect } = this.props;
		const { popUpTransforms, popUpDims } = this.state;

		if (popUpTransforms[sectionId]) {
			const transformX = popUpTransforms[sectionId].x;
			const transformY = popUpTransforms[sectionId].y;
			return `translate(${transformX}px, ${transformY}px)`;
		}

		let transformX;
		let transformY;
		
		if (isPlanet(sectionId) || isGlyphEasterEgg(sectionId) || isFlightEasterEgg(sectionId) || isTravelerNoticesEasterEgg(sectionId)) {
			const popUpDim = popUpDims[sectionId];
			transformX = (window.innerWidth / 2) - (popUpDim.width / 2);
			transformY = (window.innerHeight / 2) - (popUpDim.height / 2);
		} else {
			const openSideBarPopUps = openedWindows.filter(id => !isPlanet(id) && !isGlyphEasterEgg(id) && !isFlightEasterEgg(id) && !isTravelerNoticesEasterEgg(id));
			const index = openSideBarPopUps.indexOf(sectionId);
			const offsetX = 20;
			const offsetY = 54;
			transformX = (castleRect.left + 12 + (index * offsetX));
			transformY = (castleRect.top + 12 + (index * offsetY));
		}

		this.setState({
			popUpTransforms: {
				...popUpTransforms,
				[sectionId]: { x: transformX, y: transformY }
			}
		});
		return `translate(${transformX}px, ${transformY}px)`;
	}


	renderPopUp(section) {
		const sidebarPopUp = section.popUp;
		const planet = section.planet;
		const easterEgg = section.easterEgg;
		const isPlanetVideo = isFlightEasterEgg(section.id);
		const lostAndFound = section.id == 'lostAndFound';
		if (!sidebarPopUp && !planet && !easterEgg) return;

		const { openedWindows, toggleWindow, imageRoot, imageRegionRoot, videoRoot, videoRegionRoot, client, sideButtonRects } = this.props;
		const { transformCenterString, draggingPopUpId, popUpZIndexes } = this.state;

		const buttonRect = sideButtonRects[section.id];
		const popUpOpen = openedWindows.includes(section.id);

		const positionIndex = popUpZIndexes[section.id] || 0;

		let openTransformString = transformCenterString;

		if (client.isDesktopWidth && popUpOpen) {
			openTransformString = this.getPopUpOpenTransformString(section.id);
		}

		const isDragging = draggingPopUpId === section.id;

		const isActive = openedWindows[openedWindows.length - 1] === section.id;
		const isIdle = openedWindows.includes(section.id) && !isActive;

		const style = popUpOpen ? {
			transform: `${openTransformString} scale(1)`,
			transitionProperty: 'transform, opacity, visibility',
			transitionDelay: '0ms, 0ms, 0ms',
			zIndex: positionIndex,
			transition: isDragging ? 'none' : 'transform .4s, opacity 0s, visibility 0s',
		} : {
			transform: buttonRect ? `translate(${buttonRect?.centerX}px, ${buttonRect?.centerY}px) scale(0)` : `${transformCenterString} scale(0)`,
			opacity: 0,
			visibility: 'hidden',
			pointerEvents: 'none',
			transitionProperty: 'transform, opacity, visibility',
			transitionDelay: '0ms, 250ms, 250ms',
			zIndex: positionIndex
		};
		const popUpCopy = sidebarPopUp?.copy || planet?.copy;

		return (
			<div
				class={
					joinClasses(
						s.popUp,
						planet && s.planetWindow,
						easterEgg && s.easterEggWindow,
						lostAndFound && s.lostAndFoundWindow,
						isPlanetVideo && s.planetVideoWindow,
						isIdle && s.idle
					)}
				ref={($ref) => this[`$${section.id}PopUp`] = $ref}
				key={`${section.id}-popUp`}
				style={style}
				onClick={() => this.props.makeActiveWindow(section.id)}
				onMouseDown={(e) => this.onPopUpDragStart(e, section.id)}
				onTouchStart={(e) => this.onPopUpDragStart(e, section.id)}
				onMouseMove={(e) => this.onPopUpDrag(e, section.id)}
				onTouchMove={(e) => this.onPopUpDrag(e, section.id)}
				onMouseUp={(e) => this.onPopUpDragEnd(e, section.id)}
				onTouchEnd={(e) => this.onPopUpDragEnd(e, section.id)}
				onMouseLeave={(e) => this.onPopUpDragEnd(e, section.id)}
			>
				<div class={s.popUpHeader}>
					<h3 class={s.popUpTitle} dangerouslySetInnerHTML={{ __html: section.id == 'passport' ? Store.get().popUpTitleOverride || popUpCopy?.title || section.name : popUpCopy?.title || section.name }} />
					<button
						class={s.closePopUpBtn}
						onClick={(e) => this.onCloseClick(e, section.id)}
						onMouseDown={(e) => e.stopPropagation()}
						onTouchStart={(e) => e.stopPropagation()}
						onMouseUp={(e) => e.stopPropagation()}
						onTouchEnd={(e) => e.stopPropagation()}
					>
						<img class={s.closePopUpBtnImg} src={`${imageRoot}/closebtn.webp`} />
						<img class={s.hoverClosePopUpBtnImg} src={`${imageRoot}/hjmp3s.webp`} />
					</button>
				</div>
				{section.id === 'boardingTimes' && (
					<BoardingTimes
						section={section}
						imageRoot={imageRoot}
						toggleWindow={toggleWindow}
					/>
				)}
				{section.id === 'passport' && (
					<Passport
						section={section}
						imageRoot={imageRoot}
						imageRegionRoot={imageRegionRoot}
						client={client}
					/>
				)}
				{section.id === 'travelerNotices' && (
					<TravelerNotices
						section={section}
						imageRoot={imageRoot}
						imageRegionRoot={imageRegionRoot}
						videoRegionRoot={videoRegionRoot}
						client={client}
						isOpen={popUpOpen}
					/>
				)}
				{section.id === 'lostAndFound' && (
					<LostAndFound
						section={section}
						imageRoot={imageRoot}
						isOpen={popUpOpen}
					/>
				)}
				{section.id === 'stayConnected' && (
					<StayConnected
						section={section}
						imageRoot={imageRoot}
					/>
				)}
				{section.id === 'watchAtHome' && (
					<WatchAtHome
						section={section}
						imageRoot={imageRoot}
					/>
				)}
				{planet && (
					<Planet
						section={section}
						imageRoot={imageRoot}
						client={client}
						assetFolder={section?.planet?.folder}
					/>
				)}
				{easterEgg && (
					<EasterEgg
						section={section}
						imageRoot={imageRoot}
						videoRoot={videoRoot}
						client={client}
						isActive={isActive}
						makeActiveWindow={(sectionId) => this.props.makeActiveWindow(sectionId)}
						onVideoEnded={(e, sectionId) => this.onCloseClick(e, sectionId)}
						ref={ref => this.$easterEgg = ref} 
					/>
				)}
			</div>
		);
	}

	render() {
		return (
			<div class={s.container}>
				{this.displayedSidebarPopUps.map(section => this.renderPopUp(section))}
				{flightList.map(flight => flight.planet && this.renderPopUp(flight))}
				{flightList.map(flight => flight.easterEgg && this.renderPopUp(flight))}
				{travelerNotices.map(notice => notice.easterEgg && this.renderPopUp(notice))}
				{glyphs.map(glyph => glyph.easterEgg && this.renderPopUp(glyph))}
			</div>
		);
	}
}
